import Vue from 'vue'
import Router from 'vue-router'
import netErrorView from '@/views/netError'
import serverErrorView from '@/views/serverError'
import LoadingView from '@/components/Loading'

Vue.use(Router)

/**
 * 处理路由页面切换时，异步组件加载过渡的处理函数
 * @param {Object} AsyncView 需要加载的组件，如 import('@/components/home/Home.vue')
 * @return {Object} 返回一个promise对象
 */
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    // 需要加载的组件 (应该是一个 `Promise` 对象)
    component: AsyncView,
    // 异步组件加载时使用的组件
    loading: LoadingView,
    // 加载失败时使用的组件
    error: serverErrorView,
    // 展示加载时组件的延时时间。默认值是 200 (毫秒)
    delay: 200,
    // 如果提供了超时时间且组件加载也超时了，
    // 则使用加载失败时使用的组件。默认值是：`Infinity`
    timeout: 10000
  });
  return Promise.resolve({
    functional: true,
    render(h, {data, children}) {
      return h(AsyncHandler, data, children);
    }
  });
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => lazyLoadView(import('@/views/index'))
    }
    , {
      path: '/pay/:productId/:skuId/:schemeNo',
      name: 'pay',
      component: () => lazyLoadView(import('@/views/pay')),
      meta: {
        title: '商品详情'
      }
    }
    , {
      path: '/pay/:productId/:skuId',
      name: 'pay',
      component: () => lazyLoadView(import('@/views/pay')),
      meta: {
        title: '商品详情'
      }
    }
    , {
      path: '/product/detail',
      name: 'productDetail',
      component: () => lazyLoadView(import('@/views/productDetail')),
      meta: {
        title: '商品详情'
      }
    }
    , {
      path: '/result',
      name: 'result',
      component: () => lazyLoadView(import('@/views/result')),
      meta: {
        title: '订单结果'
      }
    }
    , {
      path: '/history',
      name: 'history',
      component: () => lazyLoadView(import('@/views/history'))
      , meta: {
        title: '订单记录'
      }
    }
    , {
      path: '/detail',
      name: 'detail',
      component: () => lazyLoadView(import('@/views/detail')),
      meta: {
        title: '订单详情'
      }
    }
    , {
      path: '/faq',
      name: 'faq',
      component: () => lazyLoadView(import('@/views/faq')),
      meta: {
        title: '常见问题'
      }
    }
    , {
      path: '/jump',
      name: 'jump',
      component: () => lazyLoadView(import('@/views/jump'))
    }
    , {
      path: '/servererror',
      name: 'servererror',
      component: serverErrorView,
      meta: {
        title: '加载失败'
      }
    }
    , {
      path: '/neterror',
      name: 'neterror',
      component: netErrorView,
      meta: {
        title: '出错了'
      }
    }
    , {
      path: '*',
      redirect: '/'
    }
  ]
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.name !== 'pay' && to.name !== 'history' && to.name !== 'detail') { // H5微信支付
    window.sessionStorage.removeItem('cacheAccountTemporary')
    window.sessionStorage.removeItem('wxPayInfo')
    window.sessionStorage.removeItem('wxPayInfoTime')
  }
  next()
})
export default router